module.exports = __webpack_public_path__ + "static/media/BirchStd-01.4281df44.svg";